import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Col, Row} from 'react-bootstrap'
import Slider from 'react-rangeslider'
import '../components/css/IdeaRatingField.css'

const ratingMap = {
    0: 'unrated',
    1: 'low',
    2: 'high',
}

class IdeaRatingField extends Component {

    constructor(props) {
        super(props)
        this.onRating = this.onRating.bind(this)
        this.state = {
            effortRate: 0,
            impactRate: 0,
        }
    }
    componentWillReceiveProps(nextProps){
        this.setState({
            effortRate : nextProps.effortRating,
            impactRate : nextProps.impactRating,
        })
    }
    onRating(whichField, nextValue) {
        if(this.props.onChange){
            this.props.onChange(nextValue, whichField)
        }
    }

    changeRating(whichField, nextValue){
        if (whichField === 'effortRating'){
            this.setState({
                effortRate : nextValue,
            })
        }
        if (whichField === 'impactRating'){
            this.setState({
                impactRate : nextValue,
            })
        }
    }

    componentDidMount(){
        this.setState({
            effortRate: this.props.effortRating,
            impactRate: this.props.impactRating,
        })
    }

    render(){
        const numSteps = Object.keys(ratingMap).length-1
        let ratingText = ''
        let effort = Math.min(this.state.effortRate, numSteps)
        let impact = Math.min(this.state.impactRate, numSteps)
        if (isNaN(effort) || isNaN(impact) || effort===0 || impact===0)
            ratingText = 'Please rate both Effort and Impact.'
        else if (effort===1 && impact===2)
            ratingText = 'Go implement the idea now!'
        else if (effort===2 && impact===1)
            ratingText = 'This looks like a low-priority idea.'
        else if (effort===2 && impact===2)
            ratingText = 'This looks like a project, add some more detail & invite a collaborator.'
        else
            ratingText = 'Maybe this idea is worth implementing. Add some more detail & invite a collaborator to the idea.'
        return (
            <div>
                <Row>
                    <Col className='ratingField' md={6} sm={6} xs={12}>
                        <h4>Effort
                            <div style={{display: 'inline-block', marginLeft: 5+'px'}}></div>
                        </h4>
                        <div className='effortField'>
                            <Slider
                                orientation='horizontal'
                                min={0}
                                max={Object.keys(ratingMap).length-1}
                                step={1}
                                value={effort}
                                tooltip={false}
                                onChange={this.changeRating.bind(this, 'effortRating')}
                                onChangeComplete={this.onRating.bind(this, 'effortRating', this.state.effortRate)}
                            />
                        </div>
                        <div className='ratingNumber'>{ratingMap[effort]}</div>
                    </Col>
                    <Col className='ratingField' md={6} sm={6} xs={12}>
                        <h4>Impact</h4>
                        <div className='effortField'>
                            <Slider
                                orientation='horizontal'
                                min={0}
                                max={Object.keys(ratingMap).length-1}
                                step={1}
                                value={impact}
                                tooltip={false}
                                onChange={this.changeRating.bind(this, 'impactRating')}
                                onChangeComplete={this.onRating.bind(this, 'impactRating', this.state.impactRate)}
                            />
                        </div>
                        <div className='ratingNumber'>{ratingMap[impact]}</div>
                    </Col>
                </Row>
                <Row>
                    <Col className='ratingField' md={6} sm={6} xs={12}>
                        <div style={{float: 'left', marginTop: 30+'px', marginBottom: 30+'px'}}>
                            {this.props.effortGuideline}
                        </div>
                    </Col>
                    <Col className='ratingField' md={6} sm={6} xs={12}>
                        <div style={{float: 'left', marginTop: 30+'px', marginBottom: 30+'px'}}>
                            {this.props.impactGuideline}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div className='ratingText'>
                        <em>Recommendation:</em><br/>
                        {this.props.children} {ratingText}
                    </div>
                </Row>
            </div>
        )
    }
}
IdeaRatingField.propTypes = {
    effortRating: PropTypes.number,
    impactRating: PropTypes.number,
    effortGuideline: PropTypes.string,
    impactGuideline: PropTypes.string,
    onChange: PropTypes.func,
    editing: PropTypes.bool,
    fontSize: PropTypes.number,
}
IdeaRatingField.defaultProps = {
    editing: true,
    fontSize: 16,
}

export default IdeaRatingField



// WEBPACK FOOTER //
// ./src/components/IdeaRatingField.js